import request from "@/request";

export class Api {
  static getAuthCode(params: any) {
  }
  static submit(params: any) {
    return request.post("/app-api/wb/clue/add", params);
  }
}
